import React from 'react';
import PropTypes from 'prop-types';
import ExportPDFMapsFooter from '../../../PanelFooter/components/ExportPDFMapsFooter';
import BackgroundFieldsSection from './components/BackgroundFieldsSection';
import CropColorsSection from './components/CropColorsSection';
import MapLabelsSection from './components/MapLabelsSection';
import FooterLabelsSelection from './components/FooterLabelsSelection';
import BackgroundImageSection from './components/BackgroundImageSection';
import './index.css';

const ExportPDFMapsOptionsForm = ({ selectedFields }) => {
  return (
    <div className="relative flex flex-col grow min-h-0">
      <div className="export-pdf-maps-scroll flex flex-col grow overflow-y-auto min-h-0">
        <div className="flex flex-col grow border-t border-neutral-20">
          <BackgroundImageSection />
          <BackgroundFieldsSection />
          <CropColorsSection selectedFields={selectedFields} />
          <MapLabelsSection />
          <FooterLabelsSelection />
        </div>
      </div>
      <ExportPDFMapsFooter step={1} selectedFields={selectedFields} />
    </div>
  );
};
ExportPDFMapsOptionsForm.propTypes = {
  selectedFields: PropTypes.arrayOf.isRequired
};

export default ExportPDFMapsOptionsForm;
